import { styled } from '@mui/material';

 import { Typography, Box, BoxContainer } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { TPrototypeReportPasswordShortInfo } from '@app-velocity/av-api-v2';

const StyledScenarioChallenge = styled(Typography)({
  color: 'var(--color-neutral-700)',
});

const StyledPrompt = styled(Typography)({
  fontSize: 18,
  fontWeight: 600,
});

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

export type ScenarioInfoProps = {
  scenario: TPrototypeReportPasswordShortInfo
}

export const ScenarioInfo = ({ scenario }: ScenarioInfoProps) => {
  const { t } = useI18n();

  return (
    <BoxContainer>
      <StyledBox>
        <StyledScenarioChallenge>
          {t('prototypes:report_invitation.text', {
            name: scenario.name,
          })}
        </StyledScenarioChallenge>
        <div>
          <StyledScenarioChallenge>
            {t('prototypes:report_invitation.prompt_subtitle')}
          </StyledScenarioChallenge>
          <StyledPrompt>{scenario.prompt}</StyledPrompt>
        </div>
      </StyledBox>
    </BoxContainer>
  );
};
